<template>
  <v-alert :title="`${value}`"
  :type="alertType"
  class="text-white">
    {{ value }} {{ suffix }}
    <span
      v-if="max"
      class="text-colour-value">
        ({{ min}} - {{ max }})
    </span>
    <span
      v-else
      class="text-colour-value">
        ({{ min}}+
    </span>
  </v-alert>
</template>

<script>
export default {
  name: 'ColouredValueSimple',
  props: ['value', 'min', 'max', 'percentage', 'suffix'],
  computed: {
    isSuccess() {
      if (this.max) {
        return this.value >= this.min && this.value <= this.max;
      }
      return this.value >= this.min;
    },
    isError() {
      return this.value < this.min || this.value > this.max;
    },
    alertType() {
      if (this.isSuccess) {
        return 'success';
      }
      return 'error';
    },
  },
};
</script>
<style scoped>
.text-colour-value {
  font-size: smaller;
  float: right;
  margin-left: 2px
}
.text-success {
  color: green;
}
.text-error {
  color: red;
}
</style>
